module.exports = __webpack_public_path__ + "static/media/Icn-aif.94d1f144.svg";